

import { Component, Vue } from 'vue-property-decorator'
import ModifyPassword from '@/components/Dialog/ModifyPassword.vue'
import ModifyAvatar from '@/components/Dialog/ModifyAvatar.vue'
import { UserModule } from '../../store/modules/user'

@Component({
  components: {
    ModifyPassword,
    ModifyAvatar,
  },
})
export default class AccountInfo extends Vue {
  private get userInfo() {
    return UserModule.userInfo
  }
  private get orgInfo() {
    return UserModule.orgInfo
  }
  private hidePassword: boolean = true
  private handleModifyPassword() {
    // (this.$refs.modifyPassword as ModifyPassword).show()
    this.$router.push({ name: 'ResetPassword', query: { isModify: '1' } })
  }
  private handleModifyAvatar() {
    (this.$refs.modifyAvatar as ModifyAvatar).show()
  }
}
